import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import axios from 'axios';
import moment from 'moment';

window.axios = axios;

axios.defaults.baseURL = 'https://media.reallyworks.xyz/listings';

Vue.config.productionTip = false;

Vue.filter('moment', function (date) {
  return moment(date);
});

Vue.filter('currency', function (value, loc = 'en-US', currency = 'USD') {
  if (!value) return '0.00';
  const formatter = new Intl.NumberFormat(loc, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.use(require('vue-moment'));

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
